export const studentUpdateTypes = {
  all: {
    value: 0,
    name: '多项',
    field: '',
  },
  phone: {
    value: 1,
    name: '手机号',
    field: 'phone',
  },
  used_card_id: {
    value: 2,
    name: '默认支付课卡',
    field: 'card_name',
  },
  student_name: {
    value: 3,
    name: '姓名',
    field: 'student_name',
  },
  nickname: {
    value: 4,
    name: '昵称',
    field: 'nickname',
  },
  selfie: {
    value: 5,
    name: '真人自拍',
    field: 'selfie',
  },
  avatar: {
    value: 6,
    name: '头像',
    field: 'avatar',
  },
  card_number: {
    value: 7,
    name: '会员号',
    field: 'card_number',
  },
  gender: {
    value: 8,
    name: '性别',
    field: 'gender',
  },
  birthday: {
    value: 9,
    name: '生日',
    field: 'birthday',
  },
  id_number: {
    value: 10,
    name: '证件号',
    field: 'id_number',
  },
};

export function findStudentUpdateType(studentUpdateTypeValue) {
  for (const key in studentUpdateTypes) {
    if (studentUpdateTypeValue === studentUpdateTypes[key].value) return [studentUpdateTypes[key]];
  }
  return [{ value: -1, name: '其他' }];
}

export function getStudentUpdateTypesFilterUpdateALl() {
  let updateTypes = {};
  for (const key in studentUpdateTypes) {
    if (studentUpdateTypes[key].value === 0) continue;

    updateTypes[key] = studentUpdateTypes[key];
  }
  return updateTypes;
}
